<template lang="pug">
  .breadcrumbs
    ul.breadcrumbs-list
      li.breadcrumbs-list__item(v-for="(crumb, index) in breadcrumbsList" :key="index")
        template(v-if="index === breadcrumbsList.length - 1")
          span.breadcrumbs-list__link(v-html="crumb.name")
        template(v-else)
          nuxt-link.breadcrumbs-list__link(:to="crumb.link  + '/'") {{ crumb.name }}
</template>

<script>
export default {
  props: {
    breadcrumbsList: {
      type: Array,
      default: () => []
    }
	}
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.breadcrumbs {
  line-height: 1;

  @include mobile {
    display: none;
  }
}

.breadcrumbs-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &__item {
    &:after {
      content: '-';
      display: inline-block;
      margin: 0 3px;
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }

  &__link {
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
  }
}
</style>
